import React, { PureComponent } from 'react';
import { Redirect } from 'react-router-dom';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';

import { LOGIN_URL } from '~/data/constants/router-constants';
//constants
import { checkIsLoggedIn } from '~/redux/actions/authentication-actions';

/**
 * Higher-order component (HOC) to wrap Authenticated pages
 *
 * @export
 * @param {any} ComposedComponent
 * @returns
 */
export default function(ComposedComponent) {
	class Authenticated extends PureComponent {
		/**
		 * When the component mounts, checks for authentication
		 *
		 * @memberof Authenticated
		 */
		// componentDidMount() {
		// 	this.checkAuthentication();
		// }

		/**
		 * When a url location is changed, it also checks for authentication
		 *
		 * @param {any} nextProps
		 * @memberof Authenticated
		 */
		// componentDidUpdate(nextProps) {
		// 	if (nextProps.location !== this.props.location) {
		// 		this.checkAuthentication();
		// 	}
		// }

		/**
		 * Verifies if t he user is signed in or not.
		 * If not, redirects him to the login page.
		 *
		 * @param {any} params
		 * @memberof Authenticated
		 */
		// checkAuthentication() {
		// 	this.props.dispatch(checkIsLoggedIn());
		// }
		render() {
			// console.log(this.props.location);
			const { isLoggedIn, location } = this.props;
			if (isLoggedIn) {
				return <ComposedComponent {...this.props} />;
			} else {
				return (
					<Redirect
						to={{
							pathname: LOGIN_URL,
							state: { destinationUrl: location.pathname, hash: location.hash },
						}}
					/>
				);
			}
		}
	}

	function mapStateToProps(state) {
		return {
			isLoggedIn: state.authentication.isLoggedIn,
		};
	}

	// PropTypes

	Authenticated.defaultProps = {
		isLoggedIn: false,
	};

	Authenticated.propTypes = {
		isLoggedIn: PropTypes.bool,
	};

	return withRouter(connect(mapStateToProps)(Authenticated));
}



// WEBPACK FOOTER //
// ./src/components/general/restricted/authenticated.jsx